import {
  createDropdown,
  addListToDropdown,
  Plugin,
  ViewModel,
  Collection
} from 'ckeditor5';
import { collectionsFromGroups } from './catalogueFieldPicker';

// Loop / repeat glyph ("loop") — one iteration per item in a collection.
// Filled, no explicit fill so it inherits the button colour via currentColor.
const icon = `
<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"></path>
</svg>`;

export default class InsertRepeatingBlock extends Plugin {
  static get pluginName() {
    return 'InsertRepeatingBlock';
  }

  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('insertRepeatingBlock', (locale) => {
      const dropdownView = createDropdown(locale);
      dropdownView.buttonView.set({
        label: 'Repeat',
        tooltip: 'Insert a FOR EACH repeating block (one row per item)',
        icon,
        withText: true
      });

      dropdownView.extendTemplate({
        attributes: {
          class: ['tgc-tb-logic'],
          'data-va-anchor': 'pedigree.contact.repeatDropdown'
        }
      });

      const items = new Collection();
      const groups = editor.config.get('mergeFieldsCatalogue') || [];
      const collections = collectionsFromGroups(groups);
      if (!collections.length) {
        items.add({
          type: 'button',
          model: new ViewModel({
            label: 'No repeating fields available',
            withText: true,
            isEnabled: false
          })
        });
      }
      collections.forEach((c) => {
        items.add({
          type: 'button',
          model: new ViewModel({
            label: c.token,
            withText: true,
            _collection: c.token
          })
        });
      });
      addListToDropdown(dropdownView, items);

      dropdownView.on('execute', (evt) => {
        const collection = evt.source._collection;
        if (!collection) return;
        editor.model.change((writer) => {
          const pos = editor.model.document.selection.getFirstPosition();
          // Scaffold with a leading space where the author drops item fields.
          writer.insertText(`{{#each ${collection}}} {{/each}}`, pos);
        });
      });

      return dropdownView;
    });
  }
}
